import { render, staticRenderFns } from "./RequestOrderConfirmation.vue?vue&type=template&id=4ef0a042&scoped=true&"
import script from "./RequestOrderConfirmation.vue?vue&type=script&lang=js&"
export * from "./RequestOrderConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef0a042",
  null
  
)

export default component.exports